import React, { useState } from "react";
import { Button, Link, TextField, Typography, IconButton } from "@material-ui/core";
import "./login.css";
import logo from "../../../Assets/arc-logo.gif";
import slogan from "../../../Assets/slogan.png";
import { useDispatch } from "react-redux";
import { login } from "../../../api/auth";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { useHistory } from "react-router";
import { AUTHCOLOR, WHITE } from "../../../Theme/colorConstant";
const Login = React.memo(() => {
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const history = useHistory();
  const handleLogin = async () => {
    try {
      const params = {
        data: {
          email,
          password,
        },
      };
      const response = await dispatch(login(params));
      history.replace("/");
    } catch (err) {
      console.log(err);
    }
  };

  const loginOnEnter = (e) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <>
      <div className="login" onKeyDown={loginOnEnter}>
        <div className="left_login__container">
          <div className="left_login__inner">

            <div>
              <img src={logo} alt="Logo" className="anim_logo" />
            </div>
            <div className="slogan_logo_container">

              <img src={slogan} alt="Logo" className="slogan_logo" />
            </div>
            <div className="left_footer">
              <p style={{ color: 'white' }}>© Copyright 2023 Arc-Inventador. All rights reserved</p>
            </div>
          </div>
        </div>
        <div className="login__container">
          <div className="right_login__inner">
            <h2>Login</h2>
            <h4>Enter Your Credentials</h4>
            <div className="login__field">
              <label className="input_lable">Email * </label>
              <div className="email">
                <input type="email"
                  placeholder="example@example.com"
                  className="login_input"
                  style={{ width: "90%" }}
                  name={email}
                  label="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <label className="input_lable">Password </label>
              <div className="password">
                <input
                  placeholder="password"
                  className="login_input"
                  style={{ width: "90%" }}
                  type={!visible ? "password" : "text"}
                  name={password}
                  label="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                {password ? (
                  <IconButton
                    className="visibleBtn"
                    onClick={() => setVisible(!visible)}
                  >
                    <VisibilityIcon />
                  </IconButton>
                ) : null}
              </div>
            </div>
            <div className="loginBtn_container">
              <Button
                onClick={handleLogin}
                type="submit"
                className="loginBtn"
                style={{
                  color: WHITE,
                  width: "20%",
                }}
              >
                Login
              </Button>
            </div>
            <Typography>
              Not have an account ? <Link onClick={() => history.push('/signup')} style={{ color: '#1675ec', cursor: "pointer" }}>Signup</Link>
            </Typography>
          </div>
        </div>
      </div>
      {/* <footer className="footer">
        <Typography style={{ fontSize: '15px' }}>Powered by Arc Inventador</Typography>
      </footer> */}
    </>
  );
});

export default Login;
